module.exports = __webpack_public_path__ + "img/HD.HS.c63c5625.png";